export default "__VITE_ASSET__ba20a83b__"